// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor1 from '@/game/prefabs/World/Mentors/Mentor1';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from '@/game/scenes/TilemapScenes/TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level28 extends TilemapScene {
  constructor() {
    super('Level28');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // forest_biome_8
    const forest_biome_8 = this.add.tilemap('forest-biome-8');
    forest_biome_8.addTilesetImage(
      'summer forest wang tiles',
      'summer forest wang tiles',
    );
    forest_biome_8.addTilesetImage(
      'summer water sparkles B',
      'summer water sparkles B 16x16',
    );
    forest_biome_8.addTilesetImage('summer 32x32', 'summer 32x32');
    forest_biome_8.addTilesetImage('summer forest', 'summer forest');

    // tilemapLayers
    const tilemapLayers = this.add.container(0, 0);

    // wang_Terrain_1
    const wang_Terrain_1 = forest_biome_8.createLayer(
      'Wang Terrain',
      ['summer forest wang tiles'],
      0,
      0,
    )!;
    tilemapLayers.add(wang_Terrain_1);

    // sparkles_1
    const sparkles_1 = forest_biome_8.createLayer(
      'Sparkles',
      ['summer water sparkles B'],
      0,
      0,
    )!;
    tilemapLayers.add(sparkles_1);

    // water_Features_1
    const water_Features_1 = forest_biome_8.createLayer(
      'Water Features',
      ['summer 32x32', 'summer forest'],
      0,
      0,
    )!;
    tilemapLayers.add(water_Features_1);

    // player
    const player = new Player(this, 31, 44);
    this.add.existing(player);

    // portal
    const portal = new Portal(this, 598, 366);
    this.add.existing(portal);

    // nPC
    const nPC = new WorldNode(this, 167, 251);
    this.add.existing(nPC);

    // mentor1
    const mentor1 = new Mentor1(this, 130, 71);
    this.add.existing(mentor1);

    // nPC_1
    const nPC_1 = new WorldNode(this, 58, 233);
    this.add.existing(nPC_1);

    // nPC_2
    const nPC_2 = new WorldNode(this, 559, 89);
    this.add.existing(nPC_2);

    // nPC_3
    const nPC_3 = new WorldNode(this, 467, 96);
    this.add.existing(nPC_3);

    // nPC_4
    const nPC_4 = new WorldNode(this, 543, 141);
    this.add.existing(nPC_4);

    // nPC_5
    const nPC_5 = new WorldNode(this, 589, 298);
    this.add.existing(nPC_5);

    // nPC_6
    const nPC_6 = new WorldNode(this, 444, 373);
    this.add.existing(nPC_6);

    // nPC_7
    const nPC_7 = new WorldNode(this, 287, 182);
    this.add.existing(nPC_7);

    // nPC_8
    const nPC_8 = new WorldNode(this, 329, 37);
    this.add.existing(nPC_8);

    // nPC_9
    const nPC_9 = new WorldNode(this, 609, 444);
    this.add.existing(nPC_9);

    // forestTree1
    const forestTree1 = new ForestTree1(this, 12, 213);
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 8, 187, 'summer_trees_sheet', 0);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      357,
      350,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      623,
      322,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      383,
      24,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      169,
      34,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      631,
      457,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      406,
      370,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      402,
      217,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      478,
      259,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      625,
      55,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      624,
      165,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      473,
      46,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      538,
      32,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      512,
      69,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      396,
      86,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      551,
      266,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      286,
      20,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      157,
      18,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      626,
      229,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(this, 377, 365);
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(this, 416, 240);
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(this, 516, 257);
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(this, 443, 79);
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(this, 569, 70);
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(this, 585, 45);
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(this, 255, 29);
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(this, 195, 36);
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(this, 599, 261);
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(this, 595, 201);
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(this, 477, 204);
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(this, 606, 94);
    this.add.existing(forestTree_30);

    // forestTree_31
    const forestTree_31 = new ForestTree1(
      this,
      513,
      228,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_31);

    // forestTree_32
    const forestTree_32 = new ForestTree1(
      this,
      480,
      72,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_32);

    // forestTree_33
    const forestTree_33 = new ForestTree1(
      this,
      600,
      164,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_33);

    // forestTree_34
    const forestTree_34 = new ForestTree1(
      this,
      233,
      55,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_34);

    // forestTree_35
    const forestTree_35 = new ForestTree1(
      this,
      303,
      189,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_35);

    // nPC (prefab fields)
    nPC.NPCLevelId = 27;
    nPC.NPCId = 0;

    // nPC_1 (prefab fields)
    nPC_1.NPCLevelId = 27;
    nPC_1.NPCId = 1;

    // nPC_2 (prefab fields)
    nPC_2.NPCLevelId = 27;
    nPC_2.NPCId = 2;

    // nPC_3 (prefab fields)
    nPC_3.NPCLevelId = 27;
    nPC_3.NPCId = 3;

    // nPC_4 (prefab fields)
    nPC_4.NPCLevelId = 27;
    nPC_4.NPCId = 4;

    // nPC_5 (prefab fields)
    nPC_5.NPCLevelId = 27;
    nPC_5.NPCId = 5;

    // nPC_6 (prefab fields)
    nPC_6.NPCLevelId = 27;
    nPC_6.NPCId = 6;

    // nPC_7 (prefab fields)
    nPC_7.NPCLevelId = 27;
    nPC_7.NPCId = 7;

    // nPC_8 (prefab fields)
    nPC_8.NPCLevelId = 27;
    nPC_8.NPCId = 8;

    // nPC_9 (prefab fields)
    nPC_9.NPCLevelId = 27;
    nPC_9.NPCId = 9;

    this.player = player;
    this.portal = portal;
    this.nPC = nPC;
    this.mentor1 = mentor1;
    this.nPC_1 = nPC_1;
    this.nPC_2 = nPC_2;
    this.nPC_3 = nPC_3;
    this.nPC_4 = nPC_4;
    this.nPC_5 = nPC_5;
    this.nPC_6 = nPC_6;
    this.nPC_7 = nPC_7;
    this.nPC_8 = nPC_8;
    this.nPC_9 = nPC_9;
    this.forest_biome_8 = forest_biome_8;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private nPC!: WorldNode;
  private mentor1!: Mentor1;
  private nPC_1!: WorldNode;
  private nPC_2!: WorldNode;
  private nPC_3!: WorldNode;
  private nPC_4!: WorldNode;
  private nPC_5!: WorldNode;
  private nPC_6!: WorldNode;
  private nPC_7!: WorldNode;
  private nPC_8!: WorldNode;
  private nPC_9!: WorldNode;
  private forest_biome_8!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.forest_biome_8,
      portal: this.portal,
      mentor: this.mentor1,
    });

    /* END-USER-CODE */
  }

  /* END OF COMPILED CODE */

  // You can write more code here
}
